import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import fp from "../../../../images/firstpasslogo.svg";

import lady from "../../../../images/kiosk/lady2.gif";
import { redirectPageAction } from "store/actions";
import { IkioskManager } from "models/kioskModel";
import AutoPlayAudioPlayer from "./audioplay";

const FirstpassHome: React.FC = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation("translations");

    return (
        <>
            <div className="Kiosk_container center_bg" style={{cursor:"pointer"}} onClick={()=>dispatch(redirectPageAction(IkioskManager.HOME))}>
                <div className="main_titl">
                    <AutoPlayAudioPlayer fileName={"fp001"}/>
                    <h2> Welcome to </h2>
                    <span>
                        <img src={fp} alt="title" />
                    </span>
                    <img src={lady} alt="lady" className="talkinggirl" />
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default React.memo(FirstpassHome);